<template>
  <div>
    <ul>
      <li class="infoList">
        <span class="infoListLeft">借据号</span>
        <span class="infoListRight">{{ this.otherPages.contractInfoObj.lend_acct_no }}</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">合作平台名称</span>
        <span class="infoListRight">{{ this.otherPages.contractInfoObj.plat_name }}</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">贷款用途</span>
        <span class="infoListRight">{{ this.otherPages.contractInfoObj.loan_purpose_cn }}</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">贷款金额（大写）</span>
        <span class="infoListRight">{{ this.otherPages.contractInfoObj.loan_amt_cn }}</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">贷款期限</span>
        <span class="infoListRight">{{ this.otherPages.contractInfoObj.loan_exp }}</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">贷款起始日期</span>
        <span class="infoListRight">{{ this.otherPages.contractInfoObj.loan_start_date }}</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">贷款到期日期</span>
        <span class="infoListRight">{{ this.otherPages.contractInfoObj.loan_end_date }}</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">贷款年利率（单利）</span>
        <span class="infoListRight">{{ this.otherPages.contractInfoObj.exec_rate }}%</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">担保费率</span>
        <span class="infoListRight">{{ this.otherPages.contractInfoObj.securityRate }}%</span>
      </li>
      <li class="infoList instructionsLiStyle">
        <div class="instructionDivStyle">
          <div class="infoTopStyle">
            <span class="infoListLeft">担保费金额<span
                class="instructionsInfoStyles"
                @click="instructiionsClick"
              >缴存说明</span></span>
            <span class="infoListRight marginAmount">{{
                this.otherPages.contractInfoObj.securityAmount
                  ? toThousands(this.otherPages.contractInfoObj.securityAmount)
                  : ''
              }}元</span>
          </div>
          <div class="infoBottomSytle">
            <span class="infoListLeft promptInfoStyle">确认签署前需缴存担保金到还款账号</span>

            <span
              v-if="this.otherPages.contractInfoObj.isSecondAcct"
              class="infoListRight topUpBtn"
              @click="goToCapitalaccount"
            >充值</span>
          </div>
        </div>
      </li>
      <li class="infoList">
        <span class="infoListLeft">支付方式</span>
        <span class="infoListRight">{{ this.otherPages.contractInfoObj.paymentType === '0' ? '自主支付' : '受托支付' }}</span>
      </li>
      <div v-if="this.otherPages.contractInfoObj.paymentType === '1'">
        <li class="infoList">
          <span class="infoListLeft">放款账户户名</span>
          <span class="infoListRight">{{ this.otherPages.contractInfoObj.custName }}</span>
        </li>
        <li class="infoList">
          <span class="infoListLeft">开户网点名称</span>
          <span class="infoListRight">{{ this.otherPages.contractInfoObj.loanBankName }}</span>
        </li>
        <li class="infoList">
          <span class="infoListLeft">放款账号</span>
          <span class="infoListRight">{{ this.otherPages.contractInfoObj.loanBankNo }}</span>
        </li>
        <li class="infoList">
          <span class="infoListLeft">开户行行名</span>
          <span class="infoListRight">{{ this.otherPages.contractInfoObj.openBankName }}</span>
        </li>
        <li class="infoList">
          <span class="infoListLeft">开户行行号</span>
          <span class="infoListRight">{{ this.otherPages.contractInfoObj.openBankNo }}</span>
        </li>
        <li class="infoList">
          <span class="infoListLeft">现代支付号</span>
          <span class="infoListRight">{{ this.otherPages.contractInfoObj.paymentNo }}</span>
        </li>
      </div>
      <li class="infoList">
        <span class="infoListLeft">还款方式</span>
        <span class="infoListRight">{{ this.otherPages.contractInfoObj.repay_type_name }}</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">还款银行名称</span>
        <span class="infoListRight">{{ this.otherPages.contractInfoObj.repay_bank_name }}</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">还款账号</span>
        <span class="infoListRight">{{ this.otherPages.contractInfoObj.repay_acct_no }}</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">还款户名</span>
        <span class="infoListRight">{{ this.otherPages.contractInfoObj.repay_acct_name }}</span>
      </li>
    </ul>
    <div class="agreementTextBox">
      <img
        class="selectImg"
        @click="clickAgree()"
        :src="imgUrlAgreement"
        alt=""
      >
      <span
        class="agreementText"
        @click="clickAgree()"
      >您已阅读并同意</span> <span
        class="agreement_content"
        @click="clickConcatPop"
      >《浦银快贷个人借款合同》</span>
    </div>
    <Button
      :text="draw"
      :type="danger"
      :disabled="isDisabled"
      class="nextStep"
      :click="according"
    />
    <!-- <div class="contractDraw" @click="viewLoanContract">
      查看相关合同详情
    </div>
    <div v-show="isPopupShow" class="popupStyle">
      <PufaLoan :hidePopup="hidePopup"></PufaLoan>
    </div> -->
    <!-- 担保金缴存说明 -->
    <van-popup
      v-model="instructionsVisabld"
      closeable
      position="bottom"
      :style="{ height: '55%' }"
    >
      <InstructionsInfos />
    </van-popup>
    <van-popup
      v-model="promptViisabled"
      closeable
      position="bottom"
      :style="{ height: '45%' }"
    >
      <PromptDeposited
        :repay_acct_no="this.otherPages.contractInfoObj.repay_acct_no"
        :leftNext="goToNextPage"
        :rightNext="hidePromptViisabled"
      />
    </van-popup>
    <div
      class="loadingBox"
      v-if="this.otherPages.contractInfoObj.IsloadingBox"
    >
      <Loading
        accountFont="正在签订借款电子合同，请您耐心等候..."
        color="#fff"
        type="spinner"
      ></Loading>
    </div>
    <my-popup
      :contractId="contractId"
      v-model="isShowPopup"
      :orderId="this.otherPages.orderId"
      :drawId="this.otherPages.contractInfoObj.drawId"
    />
    <force-read-pdf-contract
      :agreeWithAgreement="agreeWithAgreement"
      :contractId="contractId"
      @checked="checked"
      v-model="forceRead"
      :orderId="this.otherPages.orderId"
      :drawId="this.otherPages.contractInfoObj.drawId"
    />
    <server-bank
      :productId="this.$route.query.productId"
      :isRelative="true"
    ></server-bank>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import NoSelect from '@/assets/images/weixuanzhong.png';
import Select from '@/assets/images/xuanzhong.png';
import Button from '@/components/Button.vue';
import { toThousands } from '@/utils/index';
import Loading from '@/components/Loading.vue';
import ServerBank from '@/components/ServerBank.vue';
import MyPopup from './components/pdfContract.vue';
import ForceReadPdfContract from './components/ForceReadPdfContract.vue';
import InstructionsInfos from './components/InstructionsInfo.vue';
import PromptDeposited from './components/promptDeposited.vue';

export default {
  name: 'signLoanContract',
  data() {
    return {
      forceRead: false,

      danger: 'danger',
      draw: '确认签署',
      isPopupShow: false,
      instructionsVisabld: false,
      promptViisabled: false,
      imgUrlAgreement: NoSelect,
      agreeWithAgreement: false,
      isShowPopup: false,
    };
  },
  components: {
    Button,
    InstructionsInfos,
    PromptDeposited,
    Loading,
    MyPopup,
    ServerBank,
    ForceReadPdfContract,
  },
  computed: {
    ...mapState({
      otherPages(val) {
        return val.otherPages;
      },
    }),
    isDisabled() {
      return !this.agreeWithAgreement;
    },
  },
  mounted() {
    this.$store.dispatch('otherPages/contDrawGenerateSpdb');
  },
  methods: {
    checked(value) {
      this.agreeWithAgreement = value;
      this.imgUrlAgreement = Select;
    },
    clickConcatPop() {
      this.isShowPopup = true;
    },
    according() {
      this.promptViisabled = true;
    },
    toThousands,
    // 以签署的逻辑
    goToNextPage() {
      this.$store.dispatch('otherPages/signDrawGenerateSpdb');
      this.promptViisabled = false;
    },
    viewLoanContract() {
      this.isPopupShow = true;
    },
    instructiionsClick() {
      this.instructionsVisabld = true;
    },
    hidePopup() {
      this.isPopupShow = false;
    },
    goToCapitalaccount() {
      // 充值跳转到转入界面
      this.$router.push('/supermarket/v2/EnterAmount');
    },
    hidePromptViisabled() {
      this.promptViisabled = false;
    },
    clickAgree() {
      console.log(this.agreeWithAgreement)
      if(!this.agreeWithAgreement) {
        this.forceRead = true;
      } else {
        this.agreeWithAgreement = false;
        this.imgUrlAgreement = NoSelect;
      }

    },
  },
};
</script>
<style scoped>
.popupStyle {
  position: absolute;
  top: 0;
  left: 0;
  background: #fff;
}
.infoList {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 90%;
  height: 50px;
  margin: 0 auto;
  border-bottom: 1px solid #eee;
}
.instructionsLiStyle {
  height: 70px;
}
.marginAmount {
  float: right;
}
.infoTopStyle {
  position: relative;
  top: -2px;
}
.infoBottomSytle {
  position: relative;
  top: 2px;
}
.instructionsInfoStyles {
  margin-left: 10px;
  color: #f65846;
}
.infoBottomSytle .topUpBtn {
  float: right;
  width: 50px;
  height: 20px;
  background: #ff6538;
  color: #ffffff;
  line-height: 20px;
  text-align: center;
}
.infoBottomSytle .promptInfoStyle {
  font-family: PingFangSC-Regular;
  color: #9ea7b4;
  letter-spacing: 0;
  font-size: 12px;
}
.infoListLeft {
  color: rgba(56, 56, 56, 1);
  font-size: 14px;
}
.infoListRight {
  color: rgba(128, 128, 128, 1);
  font-size: 14px;
}
.instructionDivStyle {
  width: 100%;
  text-align: left;
}
.nextStep {
  margin-bottom: 12px;
}
.contractDraw {
  width: 92%;
  height: 40px;
  margin: auto;
  color: rgba(212, 48, 48, 1);
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  border: 1px solid rgba(212, 48, 48, 1);
  border-radius: 3px;
}
.loadingBox {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.agreementTextBox {
  display: flex;
  justify-content: flex-start;
  position: relative;
  margin: 20px;
  padding-left: 20px;
}
.agreementText {
  color: #9ea7b4;
  font-size: 12px;
}
.agreement_content {
  color: #ff6538;
  font-size: 12px;
}
.selectImg {
  width: 12px;
  position: absolute;
  top: 3px;
  left: 0;
}
.forceReadBtn {
  width: 90%;
  background: #ff6538;
  color: #fff;
  border-radius: 4px;
  padding: 8px;
  position: fixed;
  left: 2.5%;
  bottom: 3px;
  z-index: 99;
}
.disable {
  background: #d7d7d7;
}
</style>
